<template>
  <div class="select-wrapper flex flex-col text-left">
    <label :for="id">{{ label }}</label>
    <input
      :type="data.type"
      class="regular full bordered"
      :id="id"
      v-model="localValue"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localValue: null
    };
  },
  watch: {
    localValue(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.localValue = val || "";
    }
  },
  mounted() {
    this.localValue = this.value || "";
  }
};
</script>
<style lang="scss" scope>
.select-wrapper {
  width: 100%;
  select {
    width: 100%;
  }
}
</style>
